export default __webpack_public_path__ + "bad36c79ebe00a26b3e8e4b8ba45e95c.png";